import { app, h } from 'hyperapp'
import Result from './components/result'
import Blocks from './components/blocks'
import Builder from './components/builder'
import Notice from './components/notice'
import { id, regex } from './utilities/helpers'

import '../styles/index.scss'

const App = app({
    state: {
        regex: '',
        copied: false,
        expressions: []
    },
    view: ({ expressions, copied, regex }, { addExpression, removeExpression, updateExpression, clearExpression, copyExpression }) => (
        <main class="main" role="main">
            <header class="header">
                <div class="container">
                    <Notice text="Copied" show={copied} />
                    <Result clear={clearExpression} copy={copyExpression} regex={regex} expressions={expressions} />
                    <Blocks click={removeExpression} change={updateExpression} expressions={expressions} />
                </div>
            </header>
            <div class="container">
                <Builder click={addExpression} />
            </div>
            <footer class="footer">
                <div class="container">
                    <p>A simple tool to create regular expressions. Powered by <a href="//github.com/VerbalExpressions/JSVerbalExpressions" target="_blank">VerbalExpressions</a>.</p>
                    <small>&copy; <a href="//lambry.com">Lambry</a></small>
                </div>
            </footer>
        </main>
    ),
    actions: {
        addExpression: (state, actions, expression) => {
            const expressions = [...state.expressions, { key: id(), expression, value: '' }]

            return { expressions, regex: regex(expressions) }
        },
        removeExpression: (state, actions, key) => {
            const expressions = state.expressions.filter(expression => expression.key !== key)

            return { expressions, regex: regex(expressions)  }
        },
        updateExpression: (state, actions, { key, value }) => {
            const expressions = [...state.expressions.map(expression => expression.key === key ? { ...expression, value } : { ...expression })]

            return { expressions, regex: regex(expressions) }
        },
        clearExpression: () => {
            return { expressions: [], regex: '' }
        },
        copyExpression: ({ regex }, { showCopied, hideCopied }) => {
            navigator.clipboard && navigator.clipboard.writeText(regex.toRegExp())
                .then(() => {
                    showCopied()
                    setTimeout(() => hideCopied(), 2000)
                })
                .catch(() => ({ copied: false }))

        },
        showCopied: () => {
            return { copied: true }
        },
        hideCopied: () => {
            return { copied: false }
        }
    }
})

export default App



// WEBPACK FOOTER //
// ./src/scripts/index.js